import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@mui/material'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Arrow from 'src/assets/CdBalance_Images/Arrow1.svg'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { formatDateTime } from 'src/utils/commonMethods/formatDate'
import { getClientId } from 'src/utils/commonMethods'
import { FETCH_ALL_CD_ACCOUNTS_FOR_CLIENTS } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'

const CdBalanceView = () => {
  const classes = useStyles()
  const history = useHistory()
  const { clientId } = useParams()
  const userInfo = useSelector((state) => state?.userInfo)
  const requestClientId = getClientId(clientId, userInfo)

  const {
    loading: cdAccountForClientsLoading,
    error: cdAccountForClientsError,
    data: cdAccountForClientsData,
    refetch,
  } = useQuery(FETCH_ALL_CD_ACCOUNTS_FOR_CLIENTS(requestClientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const cdAccountLinkedViewNavigation = (id) => {
    history.push(`/individual/dashboard/CdAccountLinkedPolicies/${id}`)
  }

  useEffect(() => {
    refetch()
  }, [requestClientId, refetch])

  const backNavigation = () => {
    history.push('/individual/dashboard/company')
  }

  if (cdAccountForClientsError) {
    return <GraphQlErrors error={cdAccountForClientsError} />
  }

  const CdBalanceAccountData =
    cdAccountForClientsData?.fetchAllCdAccountsForClient?.data
  const CdAccountData = CdBalanceAccountData?.cdAccountsDetails

  return (
    <>
      <LoadingModal loading={cdAccountForClientsLoading} />
      <div className={classes.backContainer} onClick={backNavigation}>
        <div>
          <img src={Arrow} className={classes.arrowImage} />
        </div>
        <div>
          <span className={classes.back}>Back</span>
        </div>
      </div>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          {CdAccountData?.length > 0 ? (
            CdAccountData?.map((account) => (
              <div
                key={account?.cdAccountId}
                className={classes.itemsContainer}
              >
                <div className={classes.imageContainer}>
                  <div className={classes.textContainer}>
                    <img
                      src={
                        account?.linkedPolicies?.[0]?.provider?.image
                          ? account?.linkedPolicies?.[0]?.provider?.image
                          : '---'
                      }
                      className={classes.image}
                    />
                  </div>
                </div>
                <div className={classes.accountContainer}>
                  <Grid container className={classes.textContent}>
                    <Grid item xs={4}>
                      <div className={classes.contentText}>
                        <div className={classes.text}>
                          <span>CD A/c Number</span>
                        </div>
                        <div className={classes.subText}>
                          <span>
                            {account?.cdAccountNumber
                              ? account?.cdAccountNumber
                              : '---'}
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.contentText}>
                        <div className={classes.text}>
                          <span>Linked Policies Count</span>
                        </div>
                        <div className={classes.subText}>
                          <span>
                            {account?.linkedPolicies.length
                              ? account?.linkedPolicies.length
                              : '---'}
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.contentText}>
                        <div className={classes.text}>
                          <span>Last Updated</span>
                        </div>
                        <div className={classes.subText}>
                          <span>
                            {formatDateTime(account?.lastUpdatedOn)
                              ? formatDateTime(account?.lastUpdatedOn)
                              : '---'}
                          </span>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.viewContainer}>
                  <div className={classes.view}>
                    <span
                      onClick={() =>
                        cdAccountLinkedViewNavigation(account?.cdAccountId)
                      }
                    >
                      View all
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h1> No Data Available</h1>
          )}
        </div>
      </div>
    </>
  )
}

export default CdBalanceView
const useStyles = makeStyles({
  mainContainer: {
    alignItems: 'center',
    // marginTop: '10px',
  },
  container: {
    margin: '20px 50px',
    alignItems: 'center',
    textAlign: 'center',
  },
  textContainer: {
    textAlign: 'center',
    padding: '10px',
  },
  itemsContainer: {
    textAlign: 'center',
    alignItems: 'center',
    // flexWrap: 'wrap',
    display: 'flex',
    // justifyContent: 'space-around',
    borderRadius: '10px',
    background: '#FFF',
    margin: '30px 0px',
    border: '1px solid #BBBBBB',
    boxShadow: '1px 3px 7px -5px',
  },
  view: {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '21px',
  },
  subContent: {
    padding: '12px',
    border: '1px solid #BBBBBB',
    background: '#F1EAED',
  },
  textContent: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  valueContent: {
    background: '#F1EAED',
    padding: '12px',
    borderTop: '1px solid #BBBBBB',
  },
  imageContainer: {
    width: '15%',
  },
  accountContainer: {
    display: 'flex',
    border: '1px solid #BBBBBB',
    height: '100%',
    width: '70%',
  },
  viewContainer: {
    width: '15%',
    background: 'linear-gradient(180deg, #B92250 0%, #621A30 100%)',
    padding: '31.5px',
    color: '#fff',
    borderRadius: '0px 10px 10px 0px',
  },
  backContainer: {
    display: 'flex',
    gap: '10px',
    margin: '40px 50px 0px 50px',
    cursor: 'pointer',
  },
  arrowImage: {
    width: '15px',
  },
  back: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    lineHeight: '18px',
  },
  contentText: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontSize: '15px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    lineHeight: '21px',
    textAlign: 'center',
    padding: '10px',
    height: '100%',
    width: '100%',
  },
  subText: {
    fontSize: '15px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    lineHeight: '21px',
    textAlign: 'center',
    background: '#F1EAED',
    padding: '10px',
    height: '100%',
    width: '100%',
  },
  image: {
    width: '45px',
  },
})
